import { createRoot } from "react-dom/client";
import { KmsUnisphereProvider } from "@kaltura/mediaspace-shared-contexts";
import { Config } from "@kaltura/mediaspace-shared-data-kms-config";
import { UnisphereNotificationsProvider } from "@unisphere/notifications-runtime-react";
import { TopLevelComponentWrappers } from "./TopLevelComponentWrappers";

/**
 * Initialize Unisphere on a legacy (non-DS) page
 */
export const renderLegacyUnisphereProvider = (context: Config) => {
    const rootElement = document.createElement("div");
    const root = createRoot(rootElement);
    root.render(
        <TopLevelComponentWrappers context={context} scoped={true} cssPrefix={"legacy-unisphere"}>
            <KmsUnisphereProvider>
                <UnisphereNotificationsProvider>
                    {/* Nothing here, just render the contexts */}
                </UnisphereNotificationsProvider>
            </KmsUnisphereProvider>
        </TopLevelComponentWrappers>
    );
};
